/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import classNames from 'classnames';
import * as React from 'react';

import { getPayloadObject, getTelemetryAttributes, IPayLoad } from '../common/telemetryHelper';
import { mapToCssModules } from '../common/utilities';
import { IPaginationLinkProps } from './PaginationLink.props';

/**
 * PaginationLink component.
 */
export default class PaginationLink extends React.PureComponent<IPaginationLinkProps> {
    public static defaultProps: Partial<IPaginationLinkProps> = {
        tag: 'a',
        role: 'link'
    };

    private readonly payLoad: IPayLoad;

    constructor(props: IPaginationLinkProps) {
        super(props);
        this.payLoad = getPayloadObject('click', this.props.telemetryContent!, '');
    }

    public render(): JSX.Element {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let { className, cssModule, next, previous, tag: Tag, children, telemetryContent, ...props }: any = this.props;
        let etext: string = children;
        const paginationLinkclasses = mapToCssModules(classNames(className, 'msc-page-link'), cssModule);

        let defaultCaret;
        if (previous) {
            defaultCaret = '\u00AB';
            etext = 'previous';
        } else if (next) {
            defaultCaret = '\u00BB';
            etext = 'next';
        }

        if (children && Array.isArray(children) && children.length === 0) {
            children = null;
        }
        if (!props.href && Tag === 'a') {
            Tag = 'span';
        }

        if (previous || next) {
            children = [<span key="caret">{children || defaultCaret}</span>];
        }

        this.payLoad.contentAction.etext = etext;
        const attribute = getTelemetryAttributes(telemetryContent, this.payLoad);

        return (
            <Tag {...props} className={paginationLinkclasses} {...attribute}>
                {children}
            </Tag>
        );
    }
}
